import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

export default class extends Controller {
  static values = { accountLinkId: String }
  static targets = ['organisationAccountCategory']

  connect () {
    const self = this

    $('.ui.toggle.checkbox').checkbox()

    const organisationAccountCategoryDropdownConfig = {
      fullTextSearch: true,
      clearable: true,
      forceSelection: false,
      onChange: function (value, text, choice) {
        if (!value) {
          value = null
        }

        if (!value && !this.dataset.previousCategoryId) {
          return
        } else if (value === this.dataset.previousCategoryId) {
          return
        }

        fetchWithHandlingLoginRedirect(`/internal/api/account-link/${self.accountLinkIdValue}/category-map/${this.dataset.categoryMapId}/update`, {
          method: 'POST',
          body: JSON.stringify({
            subAccountCategoryId: this.dataset.subAccountCategoryId,
            organisationAccountCategoryId: value
          })
        })
          .then((response) => {
            if (!response.ok) {
              return Promise.reject(response)
            }

            this.dataset.previousCategoryId = value
          })
          .catch(() => {
            this.parentNode.classList.add('error')
            setTimeout(() => {
              this.parentNode.classList.remove('error')
              if (!this.dataset.previousCategoryId) {
                $(this).dropdown('clear')
              } else {
                $(this).dropdown('set selected', this.dataset.previousCategoryId)
              }
            }, 1500)
          })
      }
    }

    this.organisationAccountCategoryTargets.forEach((target) => {
      $(target).dropdown(organisationAccountCategoryDropdownConfig)
    })
  }
}
